import React from 'react';
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from './ui/select';
import { Globe } from 'lucide-react';
import { TIMEZONE_OPTIONS, currentTimeInZone } from '../lib/timezones';

/**
 * Compact timezone selector used next to the "Resume At" time picker.
 * Shows the chosen zone's current wall-clock time underneath so the operator
 * can sanity-check before opening the presenter window.
 */
export const TimezoneSelect = ({ value, onChange, disabled }) => {
  const current = currentTimeInZone(value);
  return (
    <div className="space-y-1.5">
      <div className="flex items-center justify-between">
        <div className="flex items-center gap-1.5">
          <Globe className="w-3 h-3 text-teal-400" />
          <span className="text-[11px] text-gray-400">Timezone</span>
        </div>
        <span className="text-[11px] text-gray-500">
          Now: <span className="text-gray-300 font-medium">{current}</span>
        </span>
      </div>
      <Select value={value} onValueChange={onChange} disabled={disabled}>
        <SelectTrigger
          className="bg-gray-800/50 border-gray-700 text-white h-9 text-sm"
          data-testid="timezone-select"
        >
          <SelectValue placeholder="Select timezone" />
        </SelectTrigger>
        <SelectContent className="bg-gray-900 border-gray-700 max-h-72">
          {TIMEZONE_OPTIONS.map((tz) => (
            <SelectItem
              key={tz.id}
              value={tz.id}
              className="text-white hover:bg-gray-800"
              data-testid={`timezone-option-${tz.id}`}
            >
              {tz.label}
              {tz.short && tz.id !== 'local' && (
                <span className="text-gray-500 ml-2 text-xs">{tz.short}</span>
              )}
            </SelectItem>
          ))}
        </SelectContent>
      </Select>
    </div>
  );
};

export default TimezoneSelect;
